(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blogs"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('alpine:init', () => {
		Alpine.data('blogs', ( data ) => ({
			blog_path: data.blog_path,
			pagination_type: data.pagination_type,
			blog: [],
			page: 1, 
			loading: false,
			init() {	
				var query_str = window.location.search.substring(1);
				if(query_str && query_str != ''){
					var query_parms = new URLSearchParams(query_str);
					this.page = parseInt(query_parms.get('page'));
					if(this.page > 1 && this.pagination_type != 'paginate'){ // redirect to page 1 if not on page one and using load more or infinite scroll
						location.href = this.blog_path;
					}
				}
			},
			get_blogs( concat = false, page = 1){
				var self = this;
				var request_url = self.blog_path + '?page=' + page;
				//var request_url = 'http://127.0.0.1:9292/blogs/news?page=' + page;
				self.loading = true; 
				self.page = page;
				if( concat == false ){
					self.blog = [];
				}
				fetch(request_url).then(function (response) {
					return response.text();
				}).then(function (html) {
					window.history.replaceState({},'', request_url);
					var parser = new DOMParser();
					var doc = parser.parseFromString(html, 'text/html');
					var container = doc.getElementById('ajax_blogs_container');
					if(container){
						var data = container.getAttribute('x-init');
						if( data.startsWith( 'blog=' ) ){ 
							data = JSON.parse( data.substring( 5 ) );
							self.blog = self.blog.concat(data);
						} else {
							console.error( 'section/blogs.liqud: ==>> #ajax_blogs_container x-init incorrectly formatted or missing' );
						}
					} else {
						console.error( 'section/blogs.liqud  ==>> #ajax_blogs_container missing' );
					}
					self.loading = false;
					if( !concat ){
						document.getElementById('theme_wrapper').scrollIntoView({behavior: "smooth"});
					}
				}).catch(function (err) {
					console.warn('Something went wrong.', err);
				});
			}

		}));
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-products-category"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
		// uncheckAllFilters();
		filterStatus();
		filterTabs();
		filterInit();
		
		document.querySelectorAll('input[name="sort_by"]').forEach(input => {
			input.addEventListener('change', function () {
				updateSortOptionText();
			});
		});

		updateSortOptionText();

		function uncheckAllFilters() {
			const checkedCheckboxes = document.querySelectorAll(".filter_container input[type='checkbox']:checked");

			checkedCheckboxes.forEach(checkbox => {
					checkbox.checked = false;
			});
		}

		function filterStatus() {
			const checkboxes = document.querySelectorAll(".filter_container input[type='checkbox']");

			checkboxes.forEach(checkbox => {
				checkbox.addEventListener("change", function () {
					const checkedCheckboxes = document.querySelectorAll(".filter_container input[type='checkbox']:checked");
					const selectedFilters = [];

					// Update the label text with the font-bold class
					checkboxes.forEach(cb => {
						const label = cb.nextElementSibling; // Get the corresponding label
						if (label) {
							if (cb.checked) {
								label.classList.add("font-bold"); // Add font-bold if checked
							} else {
								label.classList.remove("font-bold"); // Remove font-bold if unchecked
							}
						}
					});

					// Collect selected filters
					checkedCheckboxes.forEach(checked => {
						const optionTitle = checked.nextElementSibling ? checked.nextElementSibling.textContent.trim() : "";
						const filterTitleElement = checked.closest(".filter_container").querySelector("span.font-bold");

						selectedFilters.push({
							id: checked.id, // Add the checkbox's id
							text: `${optionTitle}` // Use bold formatting for filterTitle
						});
					});

					// Update the selected filter options container
					const selectedFilterOptionsContainer = document.querySelector(".selected-filter-options");
					if (selectedFilterOptionsContainer) {
						selectedFilterOptionsContainer.innerHTML = "";

						selectedFilters.forEach((filter, index) => {
							const filterSpan = document.createElement("span");
							filterSpan.className = "selected-filter-option";

							// Use innerHTML to apply bold formatting
							filterSpan.innerHTML = filter.text;

							// Create the "x" button (SVG icon)
							const closeButton = document.createElement("button");
							closeButton.className = "remove-filter";
							closeButton.setAttribute("data-value", filter.id); // Add the checkbox's id as data-value
							closeButton.innerHTML = `
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
									<line x1="6" y1="6" x2="18" y2="18" />
									<line x1="6" y1="18" x2="18" y2="6" />
								</svg>
							`;

							// Add an event listener to handle the removal of the filter
							closeButton.addEventListener("click", function () {
								const valueToRemove = this.getAttribute("data-value");
								const checkboxToUncheck = document.getElementById(valueToRemove);
								if (checkboxToUncheck) {
									checkboxToUncheck.checked = false; // Uncheck the checkbox
									checkboxToUncheck.dispatchEvent(new Event("change")); // Trigger the change event
								}
							});

							// Append the "x" button to the filter span
							filterSpan.appendChild(closeButton);

							// Append the filter span to the container
							selectedFilterOptionsContainer.appendChild(filterSpan);

							// Add the "|" separator if it's not the last element
							if (index < selectedFilters.length - 1) {
								const separator = document.createElement("span");
								separator.className = "filter-separator";
								separator.textContent = " | ";
								selectedFilterOptionsContainer.appendChild(separator);
							}
						});
					}
				});
			});
		}

		function filterTabs() {
			const buttons = document.querySelectorAll(".filter-tab");

			buttons.forEach(button => {
				button.addEventListener("click", function(event) {
					buttons.forEach(btn => btn.classList.remove("active"));
					this.classList.add("active");
				});
			});
		}
		function filterInit() {
			let filterContent = document.getElementById("filter-main-content");
			let button = document.getElementById("toggle-filter-btn");
			let totalCountElement = document.querySelector(".collection-filter-total-count");
			let totalCount = totalCountElement ? totalCountElement.getAttribute("data-count") : 0;

			if (window.innerWidth > 768) {
        filterContent.classList.remove("hidden");
    	}

			if (button) {
				button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="11" viewBox="0 0 20 11" fill="none">
					<line y1="2.5" x2="20" y2="2.5" stroke="black"/>
					<line y1="8.5" x2="20" y2="8.5" stroke="black"/>
					<circle cx="6.5" cy="2.5" r="2" fill="white" stroke="black"/>
					<circle cx="14.5" cy="8.5" r="2" fill="black" stroke="black"/>
				</svg> <b>Hide Filters</b> <span class="filter-count">${totalCount} results</span>`;
			}

			const checkboxes = document.querySelectorAll(".filter_container input[type='checkbox']");

			checkboxes.forEach(checkbox => {
				const checkedCheckboxes = document.querySelectorAll(".filter_container input[type='checkbox']:checked");
				const selectedFilters = [];

				checkedCheckboxes.forEach(checked => {
					const optionTitle = checked.nextElementSibling ? checked.nextElementSibling.textContent.trim() : "";
					const filterTitleElement = checked.closest(".filter_container").querySelector("span.font-bold");
					const filterTitle = filterTitleElement ? filterTitleElement.textContent.trim() : "";

					// selectedFilters.push(`${filterTitle}: ${optionTitle}`);
					selectedFilters.push({
						id: checked.id, // Add the checkbox's id
						text: `${optionTitle}` // Use bold formatting for filterTitle
					});
				});

				const selectedFilterOptionsContainer = document.querySelector(".selected-filter-options");
				if (selectedFilterOptionsContainer) {
					selectedFilterOptionsContainer.innerHTML = "";

					selectedFilters.forEach((filter, index) => {
						const filterSpan = document.createElement("span");
						filterSpan.className = "selected-filter-option";

						// Use innerHTML to apply bold formatting
						filterSpan.innerHTML = filter.text;

						// Create the "x" button (SVG icon)
						const closeButton = document.createElement("button");
						closeButton.className = "remove-filter";
						closeButton.setAttribute("data-value", filter.id); // Add the checkbox's id as data-value
						closeButton.innerHTML = `
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
								<line x1="6" y1="6" x2="18" y2="18" />
								<line x1="6" y1="18" x2="18" y2="6" />
							</svg>
						`;

						// Add an event listener to handle the removal of the filter
						closeButton.addEventListener("click", function () {
							const valueToRemove = this.getAttribute("data-value");
							const checkboxToUncheck = document.getElementById(valueToRemove);
							if (checkboxToUncheck) {
								checkboxToUncheck.checked = false; // Uncheck the checkbox
								checkboxToUncheck.dispatchEvent(new Event("change")); // Trigger the change event
							}
						});

						// Append the "x" button to the filter span
						filterSpan.appendChild(closeButton);

						// Append the filter span to the container
						selectedFilterOptionsContainer.appendChild(filterSpan);

						// Add the "|" separator if it's not the last element
						if (index < selectedFilters.length - 1) {
							const separator = document.createElement("span");
							separator.className = "filter-separator";
							separator.textContent = " | ";
							selectedFilterOptionsContainer.appendChild(separator);
						}
					});
				}
			});

			checkboxes.forEach(checkbox => {
				if (checkbox.checked == true) {
					checkbox.checked = true; // Uncheck the clicked checkbox
					checkbox.dispatchEvent(new Event('change')); // Trigger change event
				}
			});
		}

		function updateSortOptionText() {
			const selectedSortOption = getCheckedSortOption();
			const sortOptionElement = document.querySelector('.sort-option');

			if (sortOptionElement) {
				// Wrap "Sort By" in a <b> tag to make it bold
				sortOptionElement.innerHTML = `<b>Sort By:</b> ${selectedSortOption || 'Default'}`;
			}
		}
  });

	function getCheckedSortOption() {
		const checkedInput = document.querySelector('input[name="sort_by"]:checked');
		
		// Remove the bold class from all labels
		const allLabels = document.querySelectorAll('label[for^="sortby-"]');
		allLabels.forEach(label => label.classList.remove('font-bold'));

		if (checkedInput) {
			const label = document.querySelector(`label[for="${checkedInput.id}"]`);
			
			if (label) {
				label.classList.add('font-bold'); // Add the bold class to the selected label
				return label.textContent.trim(); 
			}
		}
		
		return null; 
	}
	document.getElementById("toggle-filter-btn").addEventListener("click", function () {
    let filterContent = document.getElementById("filter-main-content");
    let container = document.querySelector(".collection-category-container");
    let button = this; 
    let totalCountElement = document.querySelector(".collection-filter-total-count");
    let totalCount = totalCountElement ? totalCountElement.getAttribute("data-count") : 0;

    filterContent.classList.toggle("hidden");

    if (filterContent.classList.contains("hidden")) {
        container.style.gridTemplateColumns = "unset";
        button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="11" viewBox="0 0 20 11" fill="none">
            <line y1="2.5" x2="20" y2="2.5" stroke="black"/>
            <line y1="8.5" x2="20" y2="8.5" stroke="black"/>
            <circle cx="6.5" cy="2.5" r="2" fill="white" stroke="black"/>
            <circle cx="14.5" cy="8.5" r="2" fill="black" stroke="black"/>
        </svg> <b>Show Filters</b> <span class="filter-count">${totalCount} results</span>`;
    } else {
        container.style.gridTemplateColumns = "1fr 4fr"; // Restore the original layout
        button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="11" viewBox="0 0 20 11" fill="none">
            <line y1="2.5" x2="20" y2="2.5" stroke="black"/>
            <line y1="8.5" x2="20" y2="8.5" stroke="black"/>
            <circle cx="6.5" cy="2.5" r="2" fill="white" stroke="black"/>
            <circle cx="14.5" cy="8.5" r="2" fill="black" stroke="black"/>
        </svg> <b>Hide Filters</b> <span class="filter-count">${totalCount} results</span>`;
    }
	});
	
	function colorFilteredProduct(data) {
		const checkboxes = document.querySelectorAll(".filter_container input[type='checkbox']");
		const checkedCheckboxes = document.querySelectorAll(".filter_container input[type='checkbox']:checked");
		const selectedFilters = [];
		const colorOptions = [];

		const optimizedColors = {
			"Black Gloss": "Black Gloss",
			"Matte Steel": "Matte Steel",
			"Navy Gloss": "Navy Gloss",
			"Red Gloss": "Red Gloss",
			"Slate Gloss": "Slate Gloss",
			"Americana RedNavy": "Americana - Red-Navy",
		};

		checkboxes.forEach(checkbox => {
			checkedCheckboxes.forEach(checked => {
					const optionTitle = checked.nextElementSibling ? checked.nextElementSibling.textContent.trim() : "";
					const filterTitleElement = checked.closest(".filter_container").querySelector("span.font-bold");
					const filterTitle = filterTitleElement ? filterTitleElement.textContent.trim() : "";

					if (filterTitle.toLowerCase() === "shell colors") {
						colorOptions.push(optionTitle); 
					}

					selectedFilters.push(`${filterTitle}: ${optionTitle}`);
			});
		});
		const filteredProducts = data.filter(product => {
			if (colorOptions.length === 0) {
				product.first_loading = false;
				return true; 
			}

			if (!product.variant_title) {
				return false; 
			}

			product.first_loading = false;
			product.hidden_card = false;

			return colorOptions.some(colorOption => {
				const optimizedColor = optimizedColors[colorOption];
				return optimizedColor && product.variant_title.toLowerCase().includes(optimizedColor.toLowerCase());
			});
		});

		console.clear();

		return filteredProducts;
	}

	document.addEventListener('alpine:init', () => {
		Alpine.data('collection_products', ( data ) => ({
			collection_path: data.collection_path,
			pagination_type: data.pagination_type,
			products: [],
			content: data.content,
			page: 1, 
			loading: false,
			filters: [],
			price_gte: '',
			price_lte: '',
			html: '',
			pagination: '',
			all_products_count: false,
			mobile_filter_menu: false,
			sort_menu: false,
			sort_by: data.sort_by,
			init() {
				var self = this;
				var refresh_products = false;
				var query_str = window.location.search.substring(1);
				if(query_str && query_str != ''){
					var query_parms = new URLSearchParams(query_str);
					var query = query_str.split('&');
					query.forEach(function(term){
						if(term.startsWith('sort_by')){
							self.sort_by = query_parms.get('sort_by');
						}
						if(term.startsWith('page=')){
							self.page = parseInt(query_parms.get('page'));
							if(self.pagination_type != 'paginate'){ // redirect to page 1 if not on page one and using load more or infinite scroll
								location.href = window.location.href.replace('?page='+ self.page +'&', '?' ).replace( '?page='+ self.page, '?' );
							}
						} else if(term.startsWith('filter.v.price')){
							if(query_parms.get('filter.v.price.gte') > 0){
								self.price_gte = query_parms.get('filter.v.price.gte');
							}
							if(query_parms.get('filter.v.price.lte') > 0){
								self.price_lte = query_parms.get('filter.v.price.lte');
							}
						} else {
							self.filters.push(term);
						}
					});
				}

				this.$watch('filters', (value) => this.get_products());
				this.$watch('sort_by', (value) => this.get_products());
				// this.get_products();
			},
			get_products( concat = false, page = 1){
				var self = this;
				self.loading = true;
				self.sort_menu = false;
				self.page = page;
				var query_str = (self.page > 1 || self.filters.length > 0 || self.price_gte > 0 || self.price_lte > 0 || self.sort_by) ? '?' : '';
				query_str += self.page > 1 ? 'page=' + self.page : ''; // query page #
				query_str += (query_str != '?' && self.price_gte > 0) ? '&' : '';
				query_str += (self.price_gte > 0) ? 'filter.v.price.gte=' + self.price_gte : ''; // query min-price
				query_str += (query_str != '?' && self.price_lte > 0) ? '&' : '';
				query_str += (self.price_lte > 0) ? 'filter.v.price.lte=' + self.price_lte : ''; // query max-price
				query_str += (query_str != '?' && self.filters.length > 0) ? '&' : '';
				query_str += self.filters.length > 0 ? self.filters.join('&') : ''; // query filters
				query_str += (query_str != '?' && self.sort_by) ? '&' : '';
				query_str += (self.sort_by) ? 'sort_by=' + self.sort_by : ''; // query sorting
				if( concat == false ){
					self.products = [];
				}
				fetch(self.collection_path + query_str).then(function (response) {
					return response.text();
				}).then(function (html) {
					window.history.replaceState({}, '', self.collection_path + query_str);
					var parser = new DOMParser();
					var doc = parser.parseFromString(html, 'text/html');
					var product_container = doc.getElementById('ajax_products_container');
					if (product_container) {
						var data = product_container.getAttribute('x-init');
						if (data && data.startsWith('products=')) {
							data = JSON.parse(data.substring(9));

							var filteredProducts = colorFilteredProduct(data);
							console.log("Filtered Products:", data);
							var productCount = 0;
							filteredProducts.forEach(product => {
								if (product.hidden_card == false) {
									productCount += 1;
								} 
							});
							console.log("Filtered Products Count:", productCount);
							// var productCount = filteredProducts.length;

							// Update the filter count
							var filter_count = document.querySelector('.filter-count');
							var text = productCount + ' results';
							if (filter_count) {
									filter_count.textContent = text;
							}

							// Update the products directly in the Alpine.js component
							// self.products = self.products.concat(filteredProducts);
							self.products = filteredProducts;
							// self.products = self.products.concat(data);

						} else {
							console.error( 'section/collection-products.liqud: ==>> #ajax_products_container x-init incorrectly formatted or missing' );
						}
					} else {
						console.error( 'section/collection-products.liqud  ==>> #ajax_products_container missing' );
					}
					var all_products_count = doc.getElementById('ajax_all_products_count');
					if(all_products_count){
						var data = all_products_count.getAttribute('x-init');
						if( data.startsWith( 'all_products_count=' ) ){ 
							var count = JSON.parse( data.substring( 19 ) );
							self.all_products_count = count;
						} else {
							console.error( 'section/collection-products.liqud: ==>> #ajax_all_products_count x-init incorrectly formatted or missing' );
						}
					} else {
						console.error( 'section/collection-products.liqud  ==>> #ajax_all_products_count missing' );
					}
					self.loading = false;
					if( !concat ){
						document.getElementById('theme_wrapper').scrollIntoView({behavior: "smooth"});
					}
				}).catch(function (err) {
					console.warn('Something went wrong.', err);
				});
			},
			clear_query(){
				this.page = 1;
				this.filters = [];
				this.price_gte = '';
				this.price_lte = '';
			}
		}));
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-products-update-1"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('alpine:init', () => {
		Alpine.data('collection_products', ( data ) => ({
			collection_path: data.collection_path,
			pagination_type: data.pagination_type,
			products_1: [],
			products_2: [],
			products_3: [],
			products_4: [],
			products_5: [],
			content: data.content,
			page: 1, 
			loading: false,
			filters: [],
			price_gte: '',
			price_lte: '',
			html: '',
			pagination: '',
			all_products_count: false,
			mobile_filter_menu: false,
			sort_menu: false,
			// sort_by: data.sort_by,
			init() {
				var self = this;
				var refresh_products = false;
				var query_str = window.location.search.substring(1);
				if(query_str && query_str != ''){
					var query_parms = new URLSearchParams(query_str);
					var query = query_str.split('&');
					query.forEach(function(term){
						// if(term.startsWith('sort_by')){
						// 	self.sort_by = query_parms.get('sort_by');
						// }
						if(term.startsWith('page=')){
							self.page = parseInt(query_parms.get('page'));
							if(self.pagination_type != 'paginate'){ // redirect to page 1 if not on page one and using load more or infinite scroll
								location.href = window.location.href.replace('?page='+ self.page +'&', '?' ).replace( '?page='+ self.page, '?' );
							}
						} else if(term.startsWith('filter.v.price')){
							if(query_parms.get('filter.v.price.gte') > 0){
								self.price_gte = query_parms.get('filter.v.price.gte');
							}
							if(query_parms.get('filter.v.price.lte') > 0){
								self.price_lte = query_parms.get('filter.v.price.lte');
							}
						} else {
							self.filters.push(term);
						}
					});
				}
				this.$watch('filters', (value) => this.get_products());
				// this.$watch('sort_by', (value) => this.get_products());
			},
			get_products( concat = false, page = 1){
				var self = this;
				self.loading = true;
				self.sort_menu = false;
				self.page = page;
				var query_str = (self.page > 1 || self.filters.length > 0 || self.price_gte > 0 || self.price_lte > 0 || self.sort_by) ? '?' : '';
				query_str += self.page > 1 ? 'page=' + self.page : ''; // query page #
				query_str += (query_str != '?' && self.price_gte > 0) ? '&' : '';
				query_str += (self.price_gte > 0) ? 'filter.v.price.gte=' + self.price_gte : ''; // query min-price
				query_str += (query_str != '?' && self.price_lte > 0) ? '&' : '';
				query_str += (self.price_lte > 0) ? 'filter.v.price.lte=' + self.price_lte : ''; // query max-price
				query_str += (query_str != '?' && self.filters.length > 0) ? '&' : '';
				query_str += self.filters.length > 0 ? self.filters.join('&') : ''; // query filters
				// query_str += (query_str != '?' && self.sort_by) ? '&' : '';
				// query_str += (self.sort_by) ? 'sort_by=' + self.sort_by : ''; // query sorting
				if( concat == false ){
					self.products = [];
				}
				fetch(self.collection_path + query_str).then(function (response) {
					return response.text();
				}).then(function (html) {
					window.history.replaceState({},'', self.collection_path + query_str );
					var parser = new DOMParser();
					var doc = parser.parseFromString(html, 'text/html');
					
					for (let i = 1; i <= 5; i++) { // Replace 'someValue' with your loop's upper limit
						var product_container = doc.getElementById(`ajax_products_container_${i}`);
						if (product_container) {
							var data = product_container.getAttribute('x-init');
							if (data.startsWith(`products_${i}=`)) { 
								data = JSON.parse(data.substring(11)); // Adjust the offset dynamically if needed
								self[`products_${i}`] = self.products.concat(data);
							} else {
								console.error(`#ajax_products_container_${i} x-init incorrectly formatted or missing`);
							}
						} else {
							console.error(`#ajax_products_container_${i} missing`);
						}
					}

					var all_products_count = doc.getElementById('ajax_all_products_count');
					if(all_products_count){
						var data = all_products_count.getAttribute('x-init');
						if( data.startsWith( 'all_products_count=' ) ){ 
							var count = JSON.parse( data.substring( 19 ) );
							self.all_products_count = count;
						} else {
							console.error( 'section/collection-products.liqud: ==>> #ajax_all_products_count x-init incorrectly formatted or missing' );
						}
					} else {
						console.error( 'section/collection-products.liqud  ==>> #ajax_all_products_count missing' );
					}
					self.loading = false;
					// if( !concat ){
					// 	document.getElementById('theme_wrapper').scrollIntoView({behavior: "smooth"});
					// }
				}).catch(function (err) {
					console.warn('Something went wrong.', err);
				});
			},
			clear_query(){
				this.page = 1;
				this.filters = [];
				this.price_gte = '';
				this.price_lte = '';
			}
		}));
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-products"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('alpine:init', () => {
		Alpine.data('collection_products', ( data ) => ({
			collection_path: data.collection_path,
			pagination_type: data.pagination_type,
			products: [],
			content: data.content,
			page: 1, 
			loading: false,
			filters: [],
			price_gte: '',
			price_lte: '',
			html: '',
			pagination: '',
			all_products_count: false,
			mobile_filter_menu: false,
			sort_menu: false,
			sort_by: data.sort_by,
			init() {
				var self = this;
				var refresh_products = false;
				var query_str = window.location.search.substring(1);
				if(query_str && query_str != ''){
					var query_parms = new URLSearchParams(query_str);
					var query = query_str.split('&');
					query.forEach(function(term){
						if(term.startsWith('sort_by')){
							self.sort_by = query_parms.get('sort_by');
						}
						if(term.startsWith('page=')){
							self.page = parseInt(query_parms.get('page'));
							if(self.pagination_type != 'paginate'){ // redirect to page 1 if not on page one and using load more or infinite scroll
								location.href = window.location.href.replace('?page='+ self.page +'&', '?' ).replace( '?page='+ self.page, '?' );
							}
						} else if(term.startsWith('filter.v.price')){
							if(query_parms.get('filter.v.price.gte') > 0){
								self.price_gte = query_parms.get('filter.v.price.gte');
							}
							if(query_parms.get('filter.v.price.lte') > 0){
								self.price_lte = query_parms.get('filter.v.price.lte');
							}
						} else {
							self.filters.push(term);
						}
					});
				}
				this.$watch('filters', (value) => this.get_products());
				this.$watch('sort_by', (value) => this.get_products());
			},
			get_products( concat = false, page = 1){
				var self = this;
				self.loading = true;
				self.sort_menu = false;
				self.page = page;
				var query_str = (self.page > 1 || self.filters.length > 0 || self.price_gte > 0 || self.price_lte > 0 || self.sort_by) ? '?' : '';
				query_str += self.page > 1 ? 'page=' + self.page : ''; // query page #
				query_str += (query_str != '?' && self.price_gte > 0) ? '&' : '';
				query_str += (self.price_gte > 0) ? 'filter.v.price.gte=' + self.price_gte : ''; // query min-price
				query_str += (query_str != '?' && self.price_lte > 0) ? '&' : '';
				query_str += (self.price_lte > 0) ? 'filter.v.price.lte=' + self.price_lte : ''; // query max-price
				query_str += (query_str != '?' && self.filters.length > 0) ? '&' : '';
				query_str += self.filters.length > 0 ? self.filters.join('&') : ''; // query filters
				query_str += (query_str != '?' && self.sort_by) ? '&' : '';
				query_str += (self.sort_by) ? 'sort_by=' + self.sort_by : ''; // query sorting
				if( concat == false ){
					self.products = [];
				}
				fetch(self.collection_path + query_str).then(function (response) {
					return response.text();
				}).then(function (html) {
					window.history.replaceState({},'', self.collection_path + query_str );
					var parser = new DOMParser();
					var doc = parser.parseFromString(html, 'text/html');
					var product_container = doc.getElementById('ajax_products_container');
					if(product_container){
						var data = product_container.getAttribute('x-init')
						if( data.startsWith( 'products=' ) ){ 
							data = JSON.parse( data.substring( 9 ) );
							self.products = self.products.concat(data);
						} else {
							console.error( 'section/collection-products.liqud: ==>> #ajax_products_container x-init incorrectly formatted or missing' );
						}
					} else {
						console.error( 'section/collection-products.liqud  ==>> #ajax_products_container missing' );
					}
					var all_products_count = doc.getElementById('ajax_all_products_count');
					if(all_products_count){
						var data = all_products_count.getAttribute('x-init');
						if( data.startsWith( 'all_products_count=' ) ){ 
							var count = JSON.parse( data.substring( 19 ) );
							self.all_products_count = count;
						} else {
							console.error( 'section/collection-products.liqud: ==>> #ajax_all_products_count x-init incorrectly formatted or missing' );
						}
					} else {
						console.error( 'section/collection-products.liqud  ==>> #ajax_all_products_count missing' );
					}
					self.loading = false;
					if( !concat ){
						document.getElementById('theme_wrapper').scrollIntoView({behavior: "smooth"});
					}
				}).catch(function (err) {
					console.warn('Something went wrong.', err);
				});
			},
			clear_query(){
				this.page = 1;
				this.filters = [];
				this.price_gte = '';
				this.price_lte = '';
			}
		}));
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-list"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('alpine:init', () => {
		Alpine.data('collections_list', ( data ) => ({
			collection_path: data.collection_path,
			pagination_type: data.pagination_type,
			collections: [],
			page: 1, 
			loading: false,
			init() {	
				var query_str = window.location.search.substring(1);
				if(query_str && query_str != ''){
					var query_parms = new URLSearchParams(query_str);
					this.page = parseInt(query_parms.get('page'));
					if(this.page > 1 && this.pagination_type != 'paginate'){ // redirect to page 1 if not on page one and using load more or infinite scroll
						location.href = this.collection_path;
					}
				}
			},
			get_collections( concat = false, page = 1){
				var self = this;
				self.loading = true; 
				self.page = page;
				if( concat == false ){
					self.collections = [];
				}
				fetch(self.collection_path + '?page=' + page).then(function (response) {
					return response.text();
				}).then(function (html) {
					window.history.replaceState({},'', self.collection_path + '?page=' + page );
					var parser = new DOMParser();
					var doc = parser.parseFromString(html, 'text/html');
					var collections_container = doc.getElementById('ajax_collections_container');
					if(collections_container){
						var data = collections_container.getAttribute('x-init');
						if( data.startsWith( 'collections=' ) ){ 
							data = JSON.parse( data.substring( 12 ) );
							self.collections = self.collections.concat(data);
						} else {
							console.error( 'section/collections-list.liqud: ==>> #ajax_collections_container x-init incorrectly formatted or missing' );
						}
					} else {
						console.error( 'section/collections-list.liqud  ==>> #ajax_collections_container missing' );
					}
					console.log(self.collections);
					self.loading = false;
					if( !concat ){
						document.getElementById('theme_wrapper').scrollIntoView({behavior: "smooth"});
					}
				}).catch(function (err) {
					console.warn('Something went wrong.', err);
				});
			}

		}));
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["depict-patched-collection-products"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('alpine:init', () => {
		Alpine.data('collection_products', ( data ) => ({
			collection_path: data.collection_path,
			pagination_type: data.pagination_type,
			products: [],
			content: data.content,
			page: 1, 
			loading: false,
			filters: [],
			price_gte: '',
			price_lte: '',
			html: '',
			pagination: '',
			all_products_count: false,
			mobile_filter_menu: false,
			sort_menu: false,
			sort_by: data.sort_by,
			init() {
				var self = this;
				var refresh_products = false;
				var query_str = window.location.search.substring(1);
				if(query_str && query_str != ''){
					var query_parms = new URLSearchParams(query_str);
					var query = query_str.split('&');
					query.forEach(function(term){
						if(term.startsWith('sort_by')){
							self.sort_by = query_parms.get('sort_by');
						}
						if(term.startsWith('page=')){
							self.page = parseInt(query_parms.get('page'));
							if(self.pagination_type != 'paginate'){ // redirect to page 1 if not on page one and using load more or infinite scroll
								location.href = window.location.href.replace('?page='+ self.page +'&', '?' ).replace( '?page='+ self.page, '?' );
							}
						} else if(term.startsWith('filter.v.price')){
							if(query_parms.get('filter.v.price.gte') > 0){
								self.price_gte = query_parms.get('filter.v.price.gte');
							}
							if(query_parms.get('filter.v.price.lte') > 0){
								self.price_lte = query_parms.get('filter.v.price.lte');
							}
						} else {
							self.filters.push(term);
						}
					});
				}
				this.$watch('filters', (value) => this.get_products());
				this.$watch('sort_by', (value) => this.get_products());
			},
			get_products( concat = false, page = 1){
				var self = this;
				self.loading = true;
				self.sort_menu = false;
				self.page = page;
				var query_str = (self.page > 1 || self.filters.length > 0 || self.price_gte > 0 || self.price_lte > 0 || self.sort_by) ? '?' : '';
				query_str += self.page > 1 ? 'page=' + self.page : ''; // query page #
				query_str += (query_str != '?' && self.price_gte > 0) ? '&' : '';
				query_str += (self.price_gte > 0) ? 'filter.v.price.gte=' + self.price_gte : ''; // query min-price
				query_str += (query_str != '?' && self.price_lte > 0) ? '&' : '';
				query_str += (self.price_lte > 0) ? 'filter.v.price.lte=' + self.price_lte : ''; // query max-price
				query_str += (query_str != '?' && self.filters.length > 0) ? '&' : '';
				query_str += self.filters.length > 0 ? self.filters.join('&') : ''; // query filters
				query_str += (query_str != '?' && self.sort_by) ? '&' : '';
				query_str += (self.sort_by) ? 'sort_by=' + self.sort_by : ''; // query sorting
				if( concat == false ){
					self.products = [];
				}
				fetch(self.collection_path + query_str).then(function (response) {
					return response.text();
				}).then(function (html) {
					window.history.replaceState({},'', self.collection_path + query_str );
					var parser = new DOMParser();
					var doc = parser.parseFromString(html, 'text/html');
					var product_container = doc.getElementById('ajax_products_container');
					if(product_container){
						var data = product_container.getAttribute('x-init')
						if( data.startsWith( 'products=' ) ){ 
							data = JSON.parse( data.substring( 9 ) );
							self.products = self.products.concat(data);
						} else {
							console.error( 'section/collection-products.liqud: ==>> #ajax_products_container x-init incorrectly formatted or missing' );
						}
					} else {
						console.error( 'section/collection-products.liqud  ==>> #ajax_products_container missing' );
					}
					var all_products_count = doc.getElementById('ajax_all_products_count');
					if(all_products_count){
						var data = all_products_count.getAttribute('x-init');
						if( data.startsWith( 'all_products_count=' ) ){ 
							var count = JSON.parse( data.substring( 19 ) );
							self.all_products_count = count;
						} else {
							console.error( 'section/collection-products.liqud: ==>> #ajax_all_products_count x-init incorrectly formatted or missing' );
						}
					} else {
						console.error( 'section/collection-products.liqud  ==>> #ajax_all_products_count missing' );
					}
					self.loading = false;
					if( !concat ){
						document.getElementById('theme_wrapper').scrollIntoView({behavior: "smooth"});
					}
				}).catch(function (err) {
					console.warn('Something went wrong.', err);
				});
			},
			clear_query(){
				this.page = 1;
				this.filters = [];
				this.price_gte = '';
				this.price_lte = '';
			}
		}));
	});

  } catch(e) { console.error(e); }
})();
})();
